module.exports = __webpack_public_path__ + "static/media/arrow-up-small.51ead1a9.svg";